import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/45fd9e6fd13c0271.jpg';
import Video from '../../assets/45fd9e6fd13c0271.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const TeflonCoatingSection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: '#334f65',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: (isMobile && !isPad) ? isEng ? '202px' : isChina ? '119px' : '163px' : `${topSectionBottom}px`,
            transform: isPad ? 'scale(0.80)' : 'scale(1)',
            transformOrigin: 'left bottom',
          }}
        >Teflon Coating<br />Piping</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '190px' : isChina ? `102px` : `146px` }),
          }}
        >
          <Trans i18nKey='비비테크는 고온, 화학물질, 고습 등 극한 환경에서도 뛰어난 성능을 유지할 수 있도록 우수한 내화학성 및 내열성을 갖춘 불소수지(테프론) 코팅 솔루션을 제공합니다. 이 기술은 장비의 수명 연장과 공정 안정성 확보에 핵심적인 역할을 합니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default TeflonCoatingSection1;
